import React, { useEffect, useState } from "react";
import "../Header/Header.css";
import logo from "../Header/header_logo.png";
import { FaUser } from "react-icons/fa";

const Header = ({ title, onMenuClick }) => {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    if (user) {
      setUserName(user.AdminUsername || user.mobile || "Admin");
    }
  }, []);

  return (
    <div className="header-container">
      <div className="header-left">
        <div className="header-logo">
          <img src={logo} alt="Logo" />
        </div>
      </div>

      <div className="header-title">{title}</div>

      <div className="header-profile">
        <FaUser className="profile-icon" />
        <p>{userName}</p>
      </div>
    </div>
  );
};

export default Header;